import React from "react";

//íconos de trazo para los controles de la vista 360: mismo grosor y terminación que los del asistente,
//así la barra del player y la del asistente se leen como una sola interfaz
const Icono = ({ children, tam = 22 }) => (
  <svg
    className="p360-ic"
    width={tam}
    height={tam}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const IcCarrito = () => (
  <Icono>
    <circle cx="9" cy="20" r="1.4" />
    <circle cx="18" cy="20" r="1.4" />
    <path d="M2 3h3l2.6 12.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2L21 7H6" />
  </Icono>
);

export const IcSonido = () => (
  <Icono>
    <path d="M11 5L6 9H3v6h3l5 4z" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13" />
  </Icono>
);

export const IcSinSonido = () => (
  <Icono>
    <path d="M11 5L6 9H3v6h3l5 4z" />
    <path d="M16 9l5 6M21 9l-5 6" />
  </Icono>
);

export const IcOjo = () => (
  <Icono tam={18}>
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </Icono>
);

export const IcMas = () => (
  <Icono>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3M11 8v6M8 11h6" />
  </Icono>
);

export const IcMenos = () => (
  <Icono>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3M8 11h6" />
  </Icono>
);

export const IcPantallaCompleta = () => (
  <Icono>
    <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
  </Icono>
);

export const IcVR = () => (
  <Icono>
    <path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h15A1.5 1.5 0 0 1 21 8.5v7a1.5 1.5 0 0 1-1.5 1.5h-4l-2-2.5h-3l-2 2.5h-4A1.5 1.5 0 0 1 3 15.5z" />
    <circle cx="8" cy="12" r="1.6" />
    <circle cx="16" cy="12" r="1.6" />
  </Icono>
);

export const IcEscenas = () => (
  <Icono>
    <rect x="3" y="4" width="8" height="7" rx="1.5" />
    <rect x="13" y="4" width="8" height="7" rx="1.5" />
    <rect x="3" y="13" width="8" height="7" rx="1.5" />
    <rect x="13" y="13" width="8" height="7" rx="1.5" />
  </Icono>
);

export const IcCompartir = () => (
  <Icono>
    <circle cx="18" cy="5" r="2.5" />
    <circle cx="6" cy="12" r="2.5" />
    <circle cx="18" cy="19" r="2.5" />
    <path d="M8.2 10.8l7.6-4.4M8.2 13.2l7.6 4.4" />
  </Icono>
);

export const IcHerramientas = () => (
  <Icono>
    <path d="M4 7h10M18 7h2M4 17h4M12 17h8" />
    <circle cx="16" cy="7" r="2" />
    <circle cx="10" cy="17" r="2" />
  </Icono>
);

export const IcAnterior = () => (
  <Icono>
    <path d="M15 6l-6 6 6 6" />
  </Icono>
);

export const IcSiguiente = () => (
  <Icono>
    <path d="M9 6l6 6-6 6" />
  </Icono>
);
